// App
export const GET_SITE_CONFIG = 'app/GET_SITE_CONFIG';
export const GET_COUNTRIES = 'app/GET_COUNTRIES';
export const GET_SEARCH_CITY = 'app/GET_SEARCH_CITY';
export const GET_POPULAR_DESTINATIONS = 'app/GET_POPULAR_DESTINATIONS';
export const GET_BIKE_TYPES = 'app/GET_BIKE_TYPES';
export const GET_EXTRA_ITEM_TYPES = 'app/GET_EXTRA_ITEM_TYPES';

export const POST_SUBSCRIPTION = 'app/POST_SUBSCRIPTION';

export const DATA_SET_CURRENCY = 'app/DATA_SET_CURRENCY';

export const CURRENCIES = [
  { value: 'GBP', title: 'GBP', symbol: '£' },
  { value: 'EUR', title: 'EUR', symbol: '€' },
  { value: 'RUB', title: 'RUB', symbol: '₽' },
  { value: 'USD', title: 'USD', symbol: '$' }
];

// Sitemap
export const GET_SITEMAP = 'sitemap/GET_SITEMAP';

// Search
export const GET_SEARCH_RESULTS = 'search/GET_SEARCH_RESULTS';
export const DATA_CLEAR_SEARCH_RESULTS = 'search/DATA_CLEAR_SEARCH_RESULTS';
export const GET_SEARCH_RESULTS_MAP = 'search/GET_SEARCH_RESULTS_MAP';
export const DATA_CLEAR_SEARCH_RESULTS_MAP = 'search/DATA_CLEAR_SEARCH_RESULTS_MAP';

// Search params
export const DATA_SEARCH_TOGGLE_BIKE_TYPE = 'search/DATA_SEARCH_TOGGLE_BIKE_TYPE';
export const DATA_SEARCH_INCLUDE_BIKE_TYPES = 'search/DATA_SEARCH_INCLUDE_BIKE_TYPES';
export const DATA_SEARCH_SET_BOOKING_PERIOD = 'search/DATA_SEARCH_SET_BOOKING_PERIOD';
export const DATA_SEARCH_SET_SEARCH_PARAMS = 'search/DATA_SEARCH_SET_SEARCH_PARAMS';
export const DATA_SEARCH_INIT_SEARCH = 'search/DATA_SEARCH_INIT_SEARCH';


// I18N
export const DATA_I18N_SET_RESOURCE = 'i18n/DATA_I18N_SET_RESOURCE';
export const DATA_I18N_SET_LANGUAGE = 'i18/DATA_I18N_SET_LANGUAGE';

// Order
export const GET_BIKE = 'order/GET_BIKE';
export const GET_BIKE_PRICES = 'order/GET_BIKE_PRICES';
export const CLEAR_BIKE = 'order/CLEAR_BIKE';
export const POST_CREATE_ORDER = 'order/POST_CREATE_ORDER';
export const GET_ORDER = 'order/GET_ORDER';
export const POST_ACCEPT_ORDER = 'order/POST_ACCEPT_ORDER';
export const POST_DECLINE_ORDER = 'order/POST_DECLINE_ORDER';
export const POST_CREATE_STRIPE_SETUP_INTENT = 'order/POST_CREATE_STRIPE_SETUP_INTENT';
export const POST_TRANSACTION = 'order/POST_TRANSACTION';
export const GET_TRANSACTION = 'order/GET_TRANSACTION';
export const DATA_ORDER_SET_COUNT = 'order/DATA_ORDER_SET_COUNT';
export const DATA_ORDER_INIT_ORDER = 'order/DATA_ORDER_INIT_ORDER';
export const DATA_ORDER_UPDATE_DETAILS = 'order/DATA_ORDER_UPDATE_DETAILS';
export const DATA_ORDER_UPDATE_DETAILS_VALIDATION = 'order/DATA_ORDER_UPDATE_DETAILS_VALIDATION';

// Companies
export const POST_REGISTER_COMPANY = 'companies/POST_REGISTER_COMPANY';
export const GET_ALL_COUNTRIES = 'companies/GET_ALL_COUNTRIES';

// Auth
export const POST_REGISTER_USER = 'auth/POST_REGISTER_USER';
export const POST_RESTORE_PASSWORD = 'auth/POST_RESTORE_PASSWORD';
export const PUT_RESTORE_PASSWORD = 'auth/PUT_RESTORE_PASSWORD';

// Profile
export const GET_PROFILE = 'profile/GET_PROFILE';
export const DATA_CLEAR_PROFILE = 'profile/DATA_CLEAR_PROFILE';

export * from './transaction';



// WEBPACK FOOTER //
// ./src/constants/index.js